import NextImage from "src/common/NextImage"

function ArrowIllustration(props) {
  return (
    <NextImage
      src='/images/down-arrow.svg'
      dimensions={[24, 139]}
      {...props}
    />
  )
}

export default ArrowIllustration
